import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Subprovider } from '@bitski/provider-engine';
import { CACHED_METHODS } from '../constants';
/*
 * Subprovider that caches values related to the user.
 */

export var AuthenticatedCacheSubprovider = /*#__PURE__*/function (_Subprovider) {
  _inherits(AuthenticatedCacheSubprovider, _Subprovider);

  var _super = _createSuper(AuthenticatedCacheSubprovider);

  function AuthenticatedCacheSubprovider(authProvider, engine) {
    var _this;

    _classCallCheck(this, AuthenticatedCacheSubprovider);

    _this = _super.call(this);
    _this.authProvider = authProvider;
    _this.cachedValues = new Map();

    if (engine) {
      engine.on('signOut', function () {
        return _this.cachedValues.clear();
      });
    }

    return _this;
  }

  _createClass(AuthenticatedCacheSubprovider, [{
    key: "handleRequest",
    value: function handleRequest(payload, next, end) {
      // Only evaluate matching methods
      if (this.supportsCache(payload.method) === false) {
        return next();
      } // Allow overriding the cache


      if (payload.skipCache) {
        return next();
      } // Load from cache


      this.checkCachedValues(payload.method).then(function (value) {
        if (value !== undefined) {
          // Value for method is cached, return value
          end(undefined, value);
        } else {
          // Value for method is not cached, fallback to fetch
          next();
        }
      }).catch(function () {
        // If method is not supported, or we encounter an error, fallback to fetch provider
        return next();
      });
    }
  }, {
    key: "supportsCache",
    value: function supportsCache(methodName) {
      return CACHED_METHODS.includes(methodName);
    }
  }, {
    key: "checkCachedValues",
    value: function checkCachedValues(methodName) {
      // First, check in-memory cache
      if (this.cachedValues.has(methodName)) {
        return Promise.resolve(this.cachedValues.get(methodName));
      } // Fallback to local-storage cache


      switch (methodName) {
        case 'eth_accounts':
          return this.getAccounts();

        default:
          return Promise.reject(new Error('Method not supported'));
      }
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      var _this2 = this;

      // TODO: Move this to a subscription model and load into memory automatically
      return this.authProvider.getUser().then(function (user) {
        if (user.accounts) {
          _this2.cachedValues.set('eth_accounts', user.accounts);

          return user.accounts;
        }

        throw new Error('Accounts not found on user');
      });
    }
  }]);

  return AuthenticatedCacheSubprovider;
}(Subprovider);